module.exports = __webpack_public_path__ + "media/images/lp_onayami-bd21e84e3f803a03b323035ee391d934.webp";